import { createSlice } from '@reduxjs/toolkit';
import NOTI_PRESET from '../Presets/NotiPreset';

const inAppNotiSlice = createSlice({
  name: 'inAppNoti',
  initialState: {
    open: false,
    title: '',
    message: '',
    icon: '',
    responseData: '',
    gubun: '',
    alarmFlag: false,
  },

  reducers: {
    showInAppNoti: (state, action) => {
      const { gubun, responseData, body } = action.payload;

      const preset = NOTI_PRESET[gubun] || NOTI_PRESET.default;

      state.open = true;
      state.title = preset.title;
      state.icon = preset.icon;
      state.responseData = responseData || '';
      state.gubun = gubun || '';

      state.alarmFlag = true;

      if (preset.useBody && body) {
        state.message = body;
      } else {
        state.message = preset.message;
      }
    },

    closeInAppNoti: (state) => {
      state.open = false;
    },

    resetAlarmFlag: (state) => {
      state.alarmFlag = false;
    },
  },
});

export const { showInAppNoti, closeInAppNoti, resetAlarmFlag } =
  inAppNotiSlice.actions;
export default inAppNotiSlice.reducer;
